import metadata from "./ForgotUserIDPage.metadata.json5";
import messages from "./ForgotUserIDPage.messages";
import styles from "./ForgotUserIDPage.module.scss";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { renderContentFromMetadata } from "@jutro/uiconfig";
import { withAuthenticationContext } from "gw-digital-auth-react";
import LoginPageHeaderComponent from "../../components/LoginPageHeaderComponent/LoginPageHeaderComponent";
import CustomStickyFlyouts from "../../components/CustomStickyFlyouts/CustomStickyFlyouts";
import CustomFooterComponent from "../../components/CustomFooterComponent/CustomFooterComponent";
import { CustomIconUtil } from "gw-portals-util-js";
import ForgotUserIDFormComponent from "../../components/ForgotUserIDFormComponent/ForgotUserIDFormComponent";


function ForgotUserIDPage(props) {
    
    useEffect(() => {
        document.title = "Forgot UserID - American Modern Insurance Group";
    });

    const overrides = {
        mainContainer: {
            className: "forgot-userid-main-container"
        },
        forgotUserIdPageContainer: {
            className: "forgot-userid-page-container"
        },
        policyholderImageContainer: {
            className: "policy-holder-image-container"
        },
        policyHolderMainImage: {
            className: "policy-holder-main-image",
            src: CustomIconUtil.getLogoSrc("account-main-image.png"),
            alt: "account-main-image"
        },
        forgotUserIdComponentFormContainer: {
            className: "forgot-userid-component-form-container"
        }    
    };

     const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            loginPageHeaderComponent: LoginPageHeaderComponent,
            forgotUserIDFormComponent: ForgotUserIDFormComponent,
            customStickyFlyouts: CustomStickyFlyouts,
            customFooterComponent: CustomFooterComponent            
        }
    };

     const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrides,
        resolvers
    );

    return renderedContentFromMetadata;
}

export default withAuthenticationContext(withRouter(ForgotUserIDPage));